export function Entities() {
  return (
    <div>
      <h1 className="text-[24px] font-semibold tracking-tight leading-[1.2]">Entities</h1>
      <p className="text-swiss-gray-500 mt-2 text-[14px]">
        Manage your legal entities and their relationships.
      </p>
    </div>
  )
}
